import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  ChevronIcon2
} from './SVGIcons';

import CatalogBtn from './CatalogBtn'
import Social from './Social'
import OffcanvasForm from './OffcanvasForm';
import MadeInRussia from './MadeInRussia';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClient: false,
      mapsLoaded: false,
      mapsError: false,
      showCallForm: false
    };
  }

  componentDidMount() {
    this.setState({
      isClient: true
    });
    // Загружаем Яндекс.Карты только после первого движения мыши или тапа
    this.loadYandexMapsOnInteraction();
  }

  loadYandexMapsOnInteraction() {
    const loadMaps = () => {
      document.removeEventListener('mousemove', loadMaps);
      document.removeEventListener('touchstart', loadMaps);
      this.loadYandexMaps();
    };
    document.addEventListener('mousemove', loadMaps, { once: true });
    document.addEventListener('touchstart', loadMaps, { once: true });
  }

  loadYandexMaps() {
    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?apikey=1b1f192d-9460-4afb-8ae3-c8fb7643c1ba&lang=ru_RU';
    script.async = true;
    
    script.onload = () => {
      this.setState({ mapsLoaded: true });
    };
    
    script.onerror = () => {
      console.error('Failed to load Yandex Maps');
      this.setState({ mapsError: true });
    };
    
    document.head.appendChild(script);
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  // Функция для парсинга координат
  parseCoords = (coordsString) => {
    if (!coordsString) return null;
    const [lat, lng] = coordsString.split(',').map(coord => parseFloat(coord.trim()));
    return [lat, lng];
  }

  // Компонент для отображения карты
  renderMap = (coords, height = '125px', mapId = 'footer-map') => {
    const { isClient, mapsLoaded, mapsError } = this.state;
    
    if (!isClient) {
      return this.renderMapPlaceholder(height);
    }

    if (mapsError) {
      return this.renderMapPlaceholder(height, 'Ошибка загрузки карты');
    }

    if (!mapsLoaded) {
      return this.renderMapPlaceholder(height, 'Загрузка карты...');
    }

    if (!coords) {
      return this.renderMapPlaceholder(height, 'Координаты не указаны');
    }

    if (typeof window !== 'undefined' && window.ymaps) {
      return (
        <div 
          id={`map-${mapId}`}
          className='w-full h-full rounded-[15px]'
          style={{ height }}
          ref={(el) => {
            if (el && !el.hasChildNodes()) {
              this.initMap(el, coords);
            }
          }}
        />
      );
    }

    return this.renderMapPlaceholder(height);
  }

  renderMapPlaceholder = (height, message = 'Загрузка карты...') => {
    return (
      <div 
        className='w-full h-full rounded-[15px] bg-[#F5F7F9] flex items-center justify-center'
        style={{ height }}
      >
        <div className='text-[#032432]/60'>{message}</div>
      </div>
    );
  }

  initMap = (container, coords) => {
    if (!window.ymaps) return;

    window.ymaps.ready(() => {
      try {
        const map = new window.ymaps.Map(container, {
          center: coords,
          zoom: 16,
          controls: ['zoomControl']
        });

        // Добавляем метку
        const placemark = new window.ymaps.Placemark(
          coords,
          {
            hintContent: 'Наш адрес',
            balloonContent: '606008, Нижегородская область, г. Дзержинск, улица Урицкого 2А, помещение Б'
          },
          {
            preset: 'islands#blueDotIcon'
          }
        );
        map.geoObjects.add(placemark);

      } catch (error) {
        console.error('Error initializing map:', error);
      }
    });
  }

  render() {
    const data = this.props?.data || {}
    const fmenu = data?.fmenu || []
    const market = data?.market || []
    const { showWindow } = this.props
    const { showCallForm, show_gt } = this.state
    
    // Парсим координаты для карты
    const mapCoords = this.parseCoords(data?.fcoords);

    return (
      <>
        <div className='xl:hidden mt-[60px] bg-[#F5F7F9] tracking-[-0.04em] pt-[25px] leading-none pb-[75px]'>
          <div className='container mb-[20px]'>
            <a href="/">
              <img src={data?.slogo} alt="logo" width={60} height={60} className='h-auto mx-auto' />
            </a>
            <div className='text-[12px] text-black/60 mt-[15px] text-center'>
              {Parser(data?.slogan)}
            </div>
            <div className='text-center mt-[20px]'>
              <MadeInRussia variant='vertical' className='w-[110px]' imgClassName='w-full' />
            </div>
            <div className='flex items-center justify-center flex-col gap-[12px] mt-[30px]'>
              <div onClick={() => showWindow()} className='text-[12px] flex items-center justify-center gap-[9px] h-[40px] bg-[#009EE3] text-white rounded-full cursor-pointer w-full'>
                <span>Связаться</span>
                <ChevronIcon2 stroke="white" />
              </div>
              <div className='text-[14px] text-black/60'>Возникли вопросы?</div>
            </div>
          </div>

          <div className='h-[1px] w-full bg-[#032E41]/10' />

          <div className='container mt-[20px]'>

            <a className='text-[#032432] text-[24px] text-center block whitespace-nowrap mx-auto' href={`tel:${data?.phone?.replace(/[-()\s]/g, '')}`}>{data?.phone}</a>
            <div className='mt-[5px] text-black/60 text-[12px] text-center'>Бесплатный звонок по России</div>
            
            {/* Кнопка Заказать звонок для мобильной версии */}
            <div 
              onClick={this.openCallForm}
              className='text-[12px] flex items-center justify-center gap-[9px] h-[40px] w-full bg-[#032432] text-white rounded-full cursor-pointer mt-[20px] hover:bg-opacity-90 transition-colors'
            >
              <span>Заказать звонок</span>
              <ChevronIcon2 stroke="white" />
            </div>

            <div className='flex items-center justify-center gap-[5px] mt-[12px]'>
              <CatalogBtn className='h-[40px] px-[16px] flex items-center justify-center gap-[6px] rounded-full bg-[#032E41] cursor-pointer mr-[7px] text-[14px]' menu={data?.katalog || []} href={data?.katalog_link} menuPosition="top" />
              <Social social={data?.social || []} width={40} />
            </div>

            {/* Блок с меню из fmenu */}
            <div className='mt-[30px] px-[25px]'>
              <div className='text-[#032432] text-[16px] text-center'>Информация</div>
              <div className='grid grid-cols-3 gap-[10px] mt-[20px]'>
                {fmenu.map((item, index) => (
                  <a 
                    key={index} 
                    className='text-[12px] text-[#032432]/60 hover:text-[#009EE3] transition-colors' 
                    href={item.url}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Блок с картой */}
            <div className='mt-[30px]'>
              <div className='mt-[20px] text-[#032432] text-[16px] text-center'>Наш адрес</div>
              <div className='mt-[10px] text-black/60 text-[12px] text-center'>{data?.faddr}</div>
              <div className='w-full h-[125px] rounded-[15px] overflow-hidden bg-[#F5F7F9] mt-[20px]'>
                {this.renderMap(mapCoords, '125px', 'footer-map-mob')}
              </div>
            </div>

            <div className='mt-[20px] text-[16px] text-[#032432] text-center w-full'>
              Покупайте продукцию Химавангард<br /><span className='text-[#032432]/60'>на маркетплейсах</span>
            </div>
            
            {/* Блок с маркетплейсами из data.market */}
            <div className='mt-[10px] flex justify-center w-full items-center gap-[9px] mb-[20px]'>
              {market.map((item, index) => (
                <a 
                  key={index} 
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className='hover:opacity-80 transition-opacity'
                >
                  <img
                    src={item.image}
                    alt={item.name || 'Маркетплейс'}
                    width={42}
                    height={42}
                    className='w-[42px] h-[42px] object-contain'
                  />
                </a>
              ))}
            </div>

            {data?.gisplink && (
              <div
                className='mt-[10px] mx-auto mb-[20px] flex gap-[10px] max-w-[200px] items-start text-[14px] text-[#032432] hover:text-[#009EE3] transition-colors'
              >
                <img src={data?.gisp} alt="ГИСП" width={48} height={50} className='flex-none' />
                <div>Мы зарегистрированы в Государственной Информационной Системе (ГИСП)</div>
              </div>
            )}

          </div>

          <div className='h-[1px] w-full bg-[#032E41]/10' />

          <div className='container text-center mt-[20px] pb-[30px]'>
            <div className='mt-[25px] text-black/60 text-[12px]'>Химавангард © {(new Date().getFullYear())}. Все права защищены</div>
            <a href={data?.pconf_link} className='mt-[10px] text-black/60 text-[12px]'>Политика конфиденциальности</a>
            <div className='mt-[10px]'>
              <a href="https://kulibin-it.ru/" target="_blank" className='text-black/60 text-[12px] hover:text-[#009EE3] transition-colors'><b>Сайт разработал Kulibin-it.ru</b></a>
            </div>
          </div>
        </div>

        <div className='mt-[80px] bg-[#F5F7F9] tracking-[-0.04em] leading-none hidden xl:block'>
          <div className='container'>
            <div className='flex items-center pt-[35px] pb-[25px] border-[#DDE3E7] border-b-[1px] mb-[22px]'>
              <a href="/">
                <img src={data?.logo} alt='logo' width={148} height={40} className='h-auto mr-[19px] hide-ru' />
                <img src={data?.enlogo} alt='logo' width={148} height={40} className='h-auto mr-[19px] hide-en' />
              </a>
              <div className='flex-none me-[40px]'>
                <MadeInRussia variant='horizontal' className='w-[205px] max-w-full' imgClassName='w-full' />
              </div>
              <div className='flex-1 text-[14px] tracking-[-0.02em] text-black/60 me-[40px]'>
                {Parser(data?.slogan)}
              </div>
              <div className='flex items-center gap-[19px]'>
                <div className='text-[14px] tracking-[-0.02em] text-black/60'>Возникли вопросы?</div>
                <div onClick={() => showWindow()} className='flex items-center gap-[9px] h-[50px] px-[25px] bg-[#009EE3] text-white rounded-full cursor-pointer text-[14px] xl:text-[16px] tracking-[-0.02em]'>
                  <span>Связаться</span>
                  <ChevronIcon2 stroke="white" />
                </div>
              </div>
            </div>
            <div className='flex gap-[50px] items-start justify-between pb-[30px] lg:pb-[100px]'>
              <div>
                <a className='font-medium text-[#032432] text-[36px] block whitespace-nowrap' href={`tel:${data?.phone?.replace(/[-()\s]/g, '')}`}>{data?.phone}</a>
                <div className='mt-[5px] text-black/60 text-[14px] tracking-[-0.02em]'>Бесплатный звонок по России</div>
                {/* Кнопка Заказать звонок для десктопной версии */}
                <div 
                  onClick={this.openCallForm}
                  className='inline-flex items-center gap-[9px] h-[40px] px-[25px] bg-[#032432] text-white rounded-full cursor-pointer mt-[10px] hover:bg-opacity-90 transition-colors'
                >
                  <span>Заказать звонок</span>
                  <ChevronIcon2 stroke="white" />
                </div>
                <div className='mt-[25px] text-black/60 text-[14px] tracking-[-0.02em]'>Химавангард © {(new Date().getFullYear())}.<br />Все права защищены</div>
                <a href={data?.pconf_link} className='mt-[15px] block text-black/60 text-[14px]'>Политика конфиденциальности</a>
                <a href="https://kulibin-it.ru/" target="_blank" className='mt-[10px] block text-black/60 text-[14px] hover:text-[#009EE3] transition-colors'><b>Сайт разработал Kulibin-it.ru</b></a>
              </div>
              
              {/* Блок с меню из fmenu */}
              <div>
                <div className='text-[#032432] text-[18px]'>Информация</div>
                <div className='grid grid-cols-2 gap-[10px] mt-[15px]'>
                  {fmenu.map((item, index) => (
                    <a 
                      key={index} 
                      className='text-[14px] tracking-[-0.02em] text-[#032432]/60 hover:text-[#009EE3] transition-colors' 
                      href={item.url}
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
              </div>
              
              <div>
                <div className='flex items-center gap-[5px]'>
                  <CatalogBtn className='h-[40px] px-[16px] flex items-center justify-center gap-[6px] rounded-full bg-[#032E41] cursor-pointer mr-[7px]' menu={data?.katalog || []} href={data?.katalog_link} menuPosition="top" />
                  <Social social={data?.social || []} width={40} />
                </div>
                <div className='mt-[10px] text-[18px] text-[#032432]'>
                  Покупайте продукцию<br />Химавангард <span className='text-[#032432]/60'>на<br />маркетплейсах</span>
                </div>
                
                {/* Блок с маркетплейсами из data.market */}
                <div className='mt-[9px] flex items-center gap-[9px]'>
                  {market.map((item, index) => (
                    <a 
                      key={index} 
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='hover:opacity-80 transition-opacity'
                    >
                      <img 
                        src={item.image} 
                        alt={item.name} 
                        width={42} 
                        height={42} 
                        className='w-[42px] h-[42px] object-contain'
                      />
                    </a>
                  ))}
                </div>

                {data?.gisplink && (
                  <div
                    className='mt-[10px] flex gap-[10px] max-w-[200px] items-start text-[14px] text-[#032432] hover:text-[#009EE3] transition-colors'
                  >
                    <img src={data?.gisp} alt="ГИСП" width={48} height={50} className='flex-none' />
                    <div>Мы зарегистрированы в Государственной Информационной Системе (ГИСП)</div>
                  </div>
                )}
              </div>
              
              {/* Блок с картой */}
              <div className='max-w-[318px]'>
                <div className='w-[318px] h-[125px] rounded-[15px] overflow-hidden bg-[#F5F7F9]'>
                  {this.renderMap(mapCoords, '125px', 'footer-map')}
                </div>
                <div className='mt-[20px] text-[#032432] text-[18px]'>Наш адрес</div>
                <div className='mt-[10px] text-black/60 text-[14px] tracking-[-0.02em]'>{data?.faddr}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Заказать звонок"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;